import { TResponse } from 'core/classes/ws/WebSocketClient'

interface IHandleServiceResponse<T extends Record<string, any>> {
  req: Promise<TResponse<T>>
  successAction: (data: T) => void
  failAction?: (data: T, error?: string) => void
  errorAction?: (error?: string) => void
}

export const handleServiceResponse = async <T extends Record<string, any>>({
  req,
  errorAction,
  successAction,
  failAction,
}: IHandleServiceResponse<T>) => {
  const res = await req
  if (res.status === 'success') {
    successAction(res.data)
    return res.data
  }

  if (res.status === 'fail' || res.status === 'error') {
    let message

    const messages = res.message || res?.data?.messages || ''

    if (Array.isArray(messages)) {
      message = messages.join('\n')
    } else {
      message = messages
    }

    if (failAction) {
      failAction(res.data, message)
    }

    if (errorAction) {
      errorAction(message)
    }

    return null
  }

  return null
}
